// third party
import { combineReducers } from 'redux';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

// project imports
import snackbarReducer from './slices/snackbar';
import customerReducer from './slices/customer';
import cartReducer from './slices/cart';
import autoDisbursementReducer from './slices/autoDisbursement';
import mailSettingsReducer from './slices/mailSettings';

// ==============================|| COMBINE REDUCER ||============================== //

const reducer = combineReducers({
  snackbar: snackbarReducer,
  cart: persistReducer(
    {
      key: 'cart',
      storage,
      keyPrefix: 'berry-'
    },
    cartReducer
  ),
  autoDisbursement: persistReducer(
    {
      key: 'autoDisbursement',
      storage,
      keyPrefix: 'berry-'
    },
    autoDisbursementReducer
  ),
  mailSettings: persistReducer(
    {
      key: 'mailSettings',
      storage,
      keyPrefix: 'berry-'
    },
    mailSettingsReducer
  ),
  customer: customerReducer
});

export default reducer;
